<template>
  <ul class="t_tab t_btn-a-bg" id="tab" :class="[{borderLine: border}, type !== 'normal' ? 'tab-' + type : '']">
    <li v-if="tabs.length>1" @click="selectTab(tab)" :class="[{active: tab.value == current}, {lh_t_item: isLh_t_item()}]" class="t_item"
        :key="'ta' + index"
        v-for="(tab,index) in tabs">{{ tab.label === '合肖' ? '六肖' : tab.label }}<!--20240624把合肖改为六肖-->
    </li>
  </ul>
</template>

<script>
  import Vue from "../../utils/bus"
  import getQuery from "../../utils/query"
  import { mapActions } from "vuex";

  export default {
    name: "index",
    props: {
      tabs: {
        type: Array,
        default() {
          return [
            {
              value: 0,
              label: '两面盘'
            },
            {
              value: 1,
              label: '单号1-10'
            },
            {
              value: 2,
              label: '冠亚和'
            },
            {
              value: 3,
              label: '冠亚组合'
            }
          ]
        }
      },
      current: {
        type: [Number, String],
        default: 0
      },
      border: false,
      type: {
        type: String,
        default: 'normal' // 'normal'
      },
    },
    data() {
      return {
        selitem: {}
      }
    },
    created() {
      let query = getQuery(location.search);
      query["index"] = query["index"] ? query["index"] : 0;
      Vue.$emit("onTab", this.tabs[query["index"]]);
      Vue.$on("onChangeTab", () => {
        Vue.$emit("onTab", this.tabs[query["index"]]);
      });
    },
    methods: {
      ...mapActions({
        onSetPlayTypeRadio: 'home/onSetPlayTypeRadio',
        onSetLhTabData: 'home/onSetLhTabData',
      }),
      // 展示六合的菜单宽度
      isLh_t_item() {
        if (this.tabs && this.tabs.length >= 1) {
          return true;
        }
        return false;
      },
      selectTab(tab) {
        this.$emit('onChangeTab', tab);
        Vue.$emit("onTab", tab);
        // 六合
        if (this.tabs && this.tabs.length >= 1) {
          this.onSetPlayTypeRadio('1');
          this.onSetLhTabData(tab);
        }
          //0703日注释掉，不然切换会卡死
        /* if(tab==this.selitem)
         {
             this.selectTab(this.tabs[0])
         }else
           this.selitem=tab;
         */
      }
    }
  }
</script>

<style scoped lang="stylus">
  .t_tab
    overflow hidden
    font-size 14px

    .t_item
      float left
      color #fff
      min-width 78px
      height 30px
      cursor pointer
      text-align center
      box-sizing border-box
      user-select none
      margin-left 10px
      line-height 36px
      background-color rgba(255, 255, 255, 0.2)

      &.active
        color #000
        background #ffffff

  .lh_t_item
    min-width 58px !important
    padding 0 8px !important
    margin-left 7px !important

  .borderLine
    position relative

    .t_item
      line-height 28px

    &:after
      left 0
      width 100%
      height 3px
      bottom 0
      content ""
      display block
      position absolute
      background-color rgba(0, 0, 0, 0.3)

  .tab-mini
    .t_item
      width 78px

    .t_item + .t_item
      margin-left 6px

  .tab-default
    border 1px solid #e6e6e6
    background linear-gradient(#fff, #f0f0f0) !important;

    .t_item
      color #000
      height: 45px;
      min-width 83px
      font-weight bold
      line-height 45px
      margin-left 0
      border 1px solid transparent
      border-right 1px solid #e6e6e6
      background-color transparent

      &.active
        color #fff
        border 1px solid #ff600a
        background linear-gradient(#ff9900, #ff6600)

</style>



// WEBPACK FOOTER //
// src/components/c_tab/index.vue